module.exports = __webpack_public_path__ + "static/img/douyin.84f60e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/douyin.png
// module id = e27n
// module chunks = 1